import React from 'react';
import { Typography, Card, CardContent, Button, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import Page from './Page';
import Header from './Header';

const Confirmation = () => {
  return (
    <Page>
      <Header text="Thank You!" subHeader="Your rental is confirmed" />
      <Card>
        <CardContent>
          <Typography variant="body1" sx={{ mb: 2 }}>
            We just emailed your receipt and booking details. Expect another update once your cloth ships along with tracking information and return reminders. If you need to modify shipping or extend the rental window, contact us at support@diycasinoparty.com.
          </Typography>
          <Stack spacing={2} direction={{ xs: 'column', sm: 'row' }}>
            <Button variant="contained" color="primary" component={RouterLink} to="/support">Contact Support</Button>
            <Button variant="outlined" component={RouterLink} to="/">Back to Home</Button>
          </Stack>
        </CardContent>
      </Card>
    </Page>
  );
};

export default Confirmation;
